// uses ./AppsSuggestionSection.less
import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';
import t from '../../../translations';
import { openSuggestion } from '../../appSuggestion/appSuggestionActionCreators';

function SuggestionSection(props) {
    if (props.disableUploadingApp || !props.userExists) {
        return null;
    }

    return (
        <div className="appSuggestionSection">
            <p>{t.filtersSuggestionSection.promoText}</p>
            <a className="appSuggestionSection-link" onClick={props.dispatchOpenSuggestion}>
                {t.filtersSuggestionSection.linkText}
            </a>
        </div>
    );
}

SuggestionSection.propTypes = {
    userExists: PropTypes.bool.isRequired,
    dispatchOpenSuggestion: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
    dispatchOpenSuggestion: openSuggestion,
};

export default connect(
    (state) => ({
        disableUploadingApp: state.user.disableUploadingApp,
    }),
    mapDispatchToProps
)(SuggestionSection);
